/* eslint-disable no-useless-escape */
function getQueryStringValue (key) {
    return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'))
}

class ContentPage {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._menu = this._elem.querySelector('.content__menu ul')
        this._content = this._elem.querySelector('.content__content ul')
        this._title = this._elem.querySelector('.title__container .sect-title')
        this._subtitle = this._elem.querySelector('.title__container .sub-title')
        this._crumb = this._elem.querySelector('.title__container .content-page-breadcrumb')
    }
    onInit () {
        // Assign click events
        const menuArray = this._menu.querySelectorAll('li a')
        const page = getQueryStringValue('page')
        let title = ''
        let subtitle = ''
        console.log(getQueryStringValue('page'))
        for (let i = 0; i < menuArray.length; i++) {
            menuArray[i].addEventListener('click', (e) => {
                e.preventDefault()
                this.updateContent(e.currentTarget.getAttribute('data-category'), e.currentTarget.innerHTML, e.currentTarget.getAttribute('data-subtitle'))
            })

            if (menuArray[i].getAttribute('data-category') === page) {
                title = menuArray[i].innerHTML
                subtitle = menuArray[i].getAttribute('data-subtitle')
            }
        }

        // Initialise start page
        if (title !== '') {
            this.updateContent(page, title, subtitle)
        }
    }
    updateContent (handle, title, subtitle) {
        // Change the current URL without refreshing the page
        const stateObj = { foo: 'bar' }
        history.pushState(stateObj, 'page 2', '?page=' + handle)

        // Change title and breadcrumb
        this._title.innerHTML = title
        this._subtitle.innerHTML = subtitle
        this._crumb.innerHTML = title

        // Hide all content apart from the one selected
        let contentArray = this._content.querySelectorAll('li')
        for (let i = 0; i < contentArray.length; i++) {
            if (contentArray[i].getAttribute('data-category') === handle) {
                contentArray[i].classList.remove('content--hidden')
            } else {
                contentArray[i].classList.add('content--hidden')
            }
        }
    }
}
export default ContentPage



// WEBPACK FOOTER //
// ./resources/scripts/components/ContentPage.js